export default class Seat {
    constructor(json) {
        for (let required of Seat.required) {
            if (!(required in json)) {
                throw new Error(
                    `[Throne][Seat] ${required} is required when instanciating a new seat`,
                );
            }
        }

        for (let k in json) {
            this[k] = json[k];
        }
    }

    toString() {
        return `Seat: A${this.access} R${this.row} S${this.seat} (${this.x}, ${this.y})`;
    }

    get pk() {
        return this.uuid || this.id;
    }
}

Seat.required = ['seat', 'access', 'row', 'x', 'y', 'uuid'];
